export const list = {
  table: {
    id: 'ID',
    companyId: 'Company ID',
    shortName: 'Short Name',
    companyName: 'Company Name',
    createdAt: 'Create Date',
  },
  buttonAction: {
    importAdd: 'Import (Add)',
    importOverwrite: 'import (Overwrite)',
    export: 'Export',
    update: 'Update',
  },
  pageHeader: {
    title: 'Customers',
    titleCustomersList: 'Personal data registration/editing',
    new: 'New',
  },
}
